import { render, staticRenderFns } from "./MyRepresentatives.vue?vue&type=template&id=d23965b6&scoped=true"
import script from "./MyRepresentatives.vue?vue&type=script&lang=js"
export * from "./MyRepresentatives.vue?vue&type=script&lang=js"
import style0 from "./MyRepresentatives.vue?vue&type=style&index=0&id=d23965b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23965b6",
  null
  
)

export default component.exports